Ext.ns('mx.plugin');

mx.plugin.Selectable = function(/*Object config*/ config) {
    this.key = 'widget';
    Ext.apply(this, config);
};

Ext.extend(mx.plugin.Selectable, Ext.util.Observable, {
    panels: {},
    init: function(/*Ext.form.GridPanel*/ panel) {
        var thiz = this;
        panel.on(
            'render',
            function() {
                if (!this.panels[this.key]) {
                    this.panels[this.key] = [];
                }
                this.panels[this.key].push(panel);
                this.panels[this.key].forEach(function(item) {
                    item.getSelectionModel().on(
                        'beforerowselect',
                        function() {
                            thiz.panels[thiz.key].forEach(function(item) {
                                item.getSelectionModel().clearSelections();
                            });
                        },
                        this
                    );
                });
            },
            this
        );
    },
});
